<div class="edit-container position-absolute d-flex flex-column z-index-3 white-background">
  <div class="re-links-container" kendoTooltip tooltipClass="em-tooltip" position="top">
    <div class="re-links">
      <button class="btn em-btn" (click)="cancelUpdate()">
        <i class="far fa-times" aria-hidden="true" title="Close Panel"></i>
      </button>
    </div>
  </div>
  <div class="row mx-0 teal-background">
    <div class="col px-2">
      <h6 class="white-font uppercase p-2 mb-0">{{ addOrEdit }} Package</h6>
    </div>
  </div>
  <ng-scrollbar class="h-100">
    <form [formGroup]="packageForm">
      <div class="row mt-2 mx-0">
        <div class="col px-2">
          <mat-form-field>
            <input
              required
              matInput
              placeholder="Package Name"
              class="capitalized"
              aria-label="Package Name"
              autocomplete="off"
              formControlName="name"
            />
          </mat-form-field>
        </div>
        <div class="col px-2">
          <mat-form-field>
            <mat-select
              placeholder="Service"
              [panelClass]="'mat-dropdown-52vh'"
              [disableOptionCentering]="true"
              [compareWith]="compareServiceTemplates"
              formControlName="serviceTemplate"
              (openedChange)="serviceSearch.value = ''"
            >
              <div class="dropdown-search sticky-top px-2">
                <i class="fas fa-search pr-2"></i>
                <input
                  type="text"
                  placeholder="Search..."
                  #serviceSearch
                  (keyup)="onServiceSearchKey($event)"
                  (keydown)="$event.stopPropagation()"
                />
              </div>
              <div *ngIf="!filteredServiceTemplates || filteredServiceTemplates.length === 0" class="no-results">
                No results found
              </div>
              <mat-option *ngFor="let serviceTemplate of filteredServiceTemplates" [value]="serviceTemplate">
                {{ serviceTemplate.serviceName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-2 mx-0">
        <div class="col px-2">
          <mat-form-field>
            <input
              type="number"
              matInput
              placeholder="Quantity"
              aria-label="Quantity"
              autocomplete="off"
              formControlName="quantity"
            />
          </mat-form-field>
        </div>
        <div class="col px-2">
          <mat-form-field>
            <input
              type="number"
              matInput
              placeholder="Price Override"
              aria-label="Price Override"
              autocomplete="off"
              formControlName="price"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-2 mx-0">
        <div class="col px-2">
          <mat-form-field>
            <input
              matInput
              placeholder="Notes"
              aria-label="Notes"
              autocomplete="off"
              formControlName="note"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-2 mx-0">
        <div class="col px-2">
          <h6 class="uppercase px-2 mx-0">Price Details</h6>
        </div>
      </div>
      <div class="row mt-2 mx-0">
        <div class="col px-2">
          <span class="p-2 mx-0" innerHTML="{{ priceDetails }}"> </span>
        </div>
      </div>
      <div class="row mt-4 mx-0">
        <div class="col text-center">
          <button
            class="btn em-btn em-btn-green mr-2"
            [disabled]="packageForm.invalid || packageForm.pristine"
            (click)="updatePackage()"
          >
            {{ addOrEdit === 'Add' ? 'Add' : 'Update' }} Package
          </button>
          <button class="btn em-btn em-btn-green" (click)="cancelUpdate()">Cancel</button>
        </div>
      </div>
    </form>
  </ng-scrollbar>
</div>
